var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "availability"
  }, [_c('div', {
    staticClass: "availability__block availability__block_desktop"
  }, [_c('Popover', {
    attrs: {
      "padding": "15px 15px 17px",
      "placement": _vm.placement
    },
    scopedSlots: _vm._u([{
      key: "handler",
      fn: function () {
        return [_vm._t("handler")];
      },
      proxy: true
    }, {
      key: "content",
      fn: function () {
        return [_c('AvailabilityContent', {
          attrs: {
            "availability": _vm.availability
          }
        })];
      },
      proxy: true
    }], null, true)
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "availability__block availability__block_mobile"
  }, [_c('span', {
    on: {
      "click": function ($event) {
        _vm.show = true;
      }
    }
  }, [_vm._t("handler")], 2), _vm._v(" "), _c('Modal', {
    attrs: {
      "show": _vm.show,
      "type": "bottom",
      "title": "Наличие товара"
    },
    on: {
      "close": function ($event) {
        _vm.show = false;
      }
    }
  }, [_c('AvailabilityContent', {
    attrs: {
      "availability": _vm.availability,
      "title": "В вашем городе"
    }
  })], 1)], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }